import { IAgendamento } from "../../../Interfaces/AssistenciaTecnica/Agendamento/AgendamentoInterfaces";
import { TModoGestaoAtendimento } from "../../../Interfaces/AtendimentoCliente/GestaoDeAtendimento/GestaoDeAtendimentoInterfaces";
import {
    IGerarDocumento,
    IListarCasosDocumentos,
} from "../../../Interfaces/VistoriaEntregaChaves/GerarDocumento/GerarDocumentoInterface";
import { IFiltroAtendimentosVistorias } from "../../../Interfaces/VistoriaEntregaChaves/ListarAtendimentosVistorias/ListarAtendimentosVistoriasInterfaces";
import { IGestaoDeEntregaChavesRequest } from "../../../Interfaces/Vistorias/VistoriaEntregaDeChaves/GestaoDeEntregaChaves";
import {
    AdcorpusCasoVistoriaServices,
    CadastrarDataDeCorteServices,
    CriarAgendamentoPorEmailClienteVistoriaService,
    ExportarExcelAtendimentosVistoriaService,
    GerarDocumentoClienteVistoriaService,
    IniciarCasoVistoriaServices,
    LiberacaoCasosVistoriaEmMassaService,
    ListarCasosDocumentosVistoriaService,
    ListarHorariosDisponiveisDataDeCorteService,
    ParalisarCasoVistoriaServices,
    PreencherLinkEmailAgendamentoClienteVistoriaService,
    PreencherTemplateEmailAgendamentoClienteService,
    ReagendarCasoVistoriaServices,
    ReenvioEmailServices,
    ReiniciarCasoVistoriaServices,
    VerificarCasoParalisadoVistoriaService,
    VistoriaEntregaDeChavesServices,
} from "../../../Services/VistoriaEntregaDeChaves/VistoriaEntregaDeChaves";
import { Controller } from "../../Controller";

export async function ListarVistoriasController(
    pagina: number,
    responseBody: IGestaoDeEntregaChavesRequest
) {
    return Controller(
        VistoriaEntregaDeChavesServices(pagina, responseBody, false)
    );
}
export async function ExportExcelListarVistoriasController(
    requestBody: IGestaoDeEntregaChavesRequest,
    SEG_ATENDIMENTOS?: TModoGestaoAtendimento | number
) {
    return Controller(
        VistoriaEntregaDeChavesServices<Blob>(0, requestBody, true)
    );
}

export async function AdcorpusCasoVistoriaController(
    ID_PRODUTO: number,
    ID_CONTA: number,
    ID_CONTATO: number
) {
    return Controller(
        AdcorpusCasoVistoriaServices(ID_PRODUTO, ID_CONTA, ID_CONTATO)
    );
}
export async function IniciarCasoVistoriaController(
    ID_PRODUTO: number,
    ID_CONTA: number,
    ID_CONTATO: number
) {
    return Controller(
        IniciarCasoVistoriaServices(ID_PRODUTO, ID_CONTA, ID_CONTATO)
    );
}

export async function ParalisarCasoVistoriaController(
    idCaso: number,
    ID_MOTIVO_NAO_PROCEDENCIA: number
) {
    return Controller(
        ParalisarCasoVistoriaServices(idCaso, ID_MOTIVO_NAO_PROCEDENCIA)
    );
}

export async function VerificarCasoParalisadoVistoriaController(
    requestBody: number[]
) {
    return Controller(VerificarCasoParalisadoVistoriaService(requestBody));
}

export async function ReiniciarCasoVistoriaController(idCaso: number) {
    return Controller(ReiniciarCasoVistoriaServices(idCaso));
}

export async function ReenvioEmailController(ID_CASO: number) {
    return Controller(ReenvioEmailServices(ID_CASO));
}

export async function ReagendarCasoVistoriaController(idCaso: number) {
    return Controller(ReagendarCasoVistoriaServices(idCaso));
}

export async function ExportarExcelAtendimentosVistoriaController(
    SEG_ATENDIMENTOS: string,
    filtro: IFiltroAtendimentosVistorias
) {
    return Controller(
        ExportarExcelAtendimentosVistoriaService(SEG_ATENDIMENTOS, filtro)
    );
}

export async function CadastrarDataDeCorteController(
    dtInicio: string,
    dtFim: string,
    idsProdutos: number[] | undefined
) {
    return Controller(
        CadastrarDataDeCorteServices(dtInicio, dtFim, idsProdutos)
    );
}

export async function LiberacaoCasosVistoriaEmMassaController(
    requestBody: {
        ID_PRODUTO: number;
        ID_CONTA: number;
        ID_CONTATO: number;
    }[]
) {
    return Controller(LiberacaoCasosVistoriaEmMassaService(requestBody));
}

export async function PreencherTemplateEmailAgendamentoClienteController(
    idUsuarioTecnico: number,
    idCaso: number,
    idDocumentoTemplate: number
) {
    return Controller(
        PreencherTemplateEmailAgendamentoClienteService(
            idUsuarioTecnico,
            idCaso,
            idDocumentoTemplate
        )
    );
}

export async function ListarHorariosDisponiveisDataDeCorteController(
    idOrganizacao: number,
    idEmpreendimento: number,
    idUnidade: number,
    idUsuarioTecnico: number
) {
    return Controller(
        ListarHorariosDisponiveisDataDeCorteService(
            idOrganizacao,
            idEmpreendimento,
            idUnidade,
            idUsuarioTecnico
        )
    );
}

export async function CriarAgendamentoPorEmailClienteVistoriaController(
    idUsuarioAtendenteCaso: number,
    idOrganizacao: string,
    requestBody: IAgendamento
) {
    return Controller(
        CriarAgendamentoPorEmailClienteVistoriaService(
            idUsuarioAtendenteCaso,
            idOrganizacao,
            requestBody
        )
    );
}

export async function PreencherLinkEmailAgendamentoClienteVistoriaController(
    idUsuarioTecnico: number,
    idCaso: number,
    dsAssunto: string,
    requestBody: string
) {
    return Controller(
        PreencherLinkEmailAgendamentoClienteVistoriaService(
            idUsuarioTecnico,
            idCaso,
            dsAssunto,
            requestBody
        )
    );
}

export async function GerarDocumentoClienteVistoriaController(
    requestBody: IGerarDocumento
) {
    return Controller(GerarDocumentoClienteVistoriaService(requestBody));
}

export async function ListarCasosDocumentosVistoriaController(
    requestBody: IListarCasosDocumentos
) {
    return Controller(ListarCasosDocumentosVistoriaService(requestBody));
}
